/**
 * AnimatedMesh — slowly rotating pastel conic mesh-gradient background.
 *
 * Used inside hero accents on landing pages (Startups/Investors/Partners).
 * Stays inside its parent via `absolute inset-0`. Pure CSS — composes
 * cheaply, no JS animation cost.
 */
import { motion } from "framer-motion";
import usePreferStaticUI from "@/lib/usePreferStaticUI";

const PALETTES = {
  sage: ["#E6F2EA", "#DDEEFF", "#FAECEE", "#E8E1F7"],
  sky:  ["#DDEEFF", "#E8E1F7", "#FAECEE", "#E6F2EA"],
  butter:["#FFF2C6", "#FAECEE", "#E8E1F7", "#E6F2EA"],
  rose: ["#FAECEE", "#E8E1F7", "#DDEEFF", "#FFF2C6"],
  lavender:["#E8E1F7", "#FAECEE", "#FFF2C6", "#E6F2EA"],
};

export const AnimatedMesh = ({
  palette = "rose",
  className = "absolute inset-0 -z-10",
  duration = 28,
  opacity = 0.55,
}) => {
  const reduced = usePreferStaticUI();
  if (reduced) return null;

  const colors = PALETTES[palette] || PALETTES.rose;
  const gradient = `conic-gradient(from 0deg at 50% 50%, ${colors[0]}, ${colors[1]}, ${colors[2]}, ${colors[3]}, ${colors[0]})`;
  return (
    <motion.div
      aria-hidden="true"
      className={className}
      style={{
        background: gradient,
        filter: "blur(60px)",
        opacity,
        willChange: "transform",
      }}
      animate={reduced ? undefined : { rotate: 360 }}
      transition={reduced ? undefined : { duration, ease: "linear", repeat: Infinity }}
    />
  );
};

export default AnimatedMesh;
